import { HttpClient } from "@angular/common/http";
import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { DialogService } from "../../../services/dialog.service";
import { BuildReleaseType, Utils } from "../../../utils/utils";
import { CustomDialogService } from "../../../services/customdialog.service";
import { SpinnerOverlayService } from "src/app/services/spinner-overlay.service";

const TYPE_CONFIG: Record<string, {
    buildReleaseType: BuildReleaseType,
    label: string,
    statusField: string,
    statusFieldsCheck?: string[], 
    dateField: string
}> = {
    opmodes: {
        buildReleaseType: BuildReleaseType.OperationModes,
        label: 'Operation Modes',
        statusField: 'OpModes',
        dateField: 'OpModesDate'
    },
    errorcodes: {
        buildReleaseType: BuildReleaseType.ErrorCodes,
        label: 'Error Codes',
        statusField: 'ErrorCodes',
        statusFieldsCheck: ['ErrorCodes', 'ErrorCodesresol'],
        dateField: 'ErrorCodesDate'
    }
};

@Component({
    selector: "deploymentstatus-popup",
    templateUrl: './deploymentstatus-popup.component.html',
    styleUrls: ['../../../style/container-tab-list.component.less', '../../../style/custom-mat-dialog.component.less'],
    standalone: false
})
export class DeploymentStatusPopup {

    columnsToDisplay = ['environment', 'status', 'infoupdateddate'];
    public dataSource = new MatTableDataSource<EventArchiveStatus>();

    public deploymentStatusInfo: EventArchiveStatus[];
    buildRelease: BuildRelease | undefined
    environments: EnviromentViewModel[] | undefined

    prodEnvironment?: EventArchiveStatus

    InfoTypeConf: typeof TYPE_CONFIG[string];

    constructor(
        private http: HttpClient
        , private dialogService: DialogService
        , public defaults: DefaultValuesService
        , @Inject('BASE_URL') private baseUrl: string
        , public dialogRef: MatDialogRef<DeploymentStatusPopup>
        , @Inject(MAT_DIALOG_DATA) public data: any
        , private dialog: MatDialog
        , private customDialog: CustomDialogService
        , private readonly spinnerOverlayService: SpinnerOverlayService
    ) {
        this.deploymentStatusInfo = [];
        // Default to first config if not found
        this.InfoTypeConf = TYPE_CONFIG[data.component];
    }

    ngOnInit() {
        this.refreshInformation()
    }

    onBack() { }

    onNoClick(): void {
        this.dialogRef.close();
    }

    public sinceDays(date: Date) {
        let currentDate = new Date();
        let dateDeployment = new Date(date);
        return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
            - Date.UTC(dateDeployment.getFullYear(), dateDeployment.getMonth(), dateDeployment.getDate())) / (1000 * 60 * 60 * 24));
    }

    onClickDeploy() {
        Utils.httpCreateBuildByControllerTypeAndInformationType(
            this.http,
            this.baseUrl,
            this,
            this.InfoTypeConf.buildReleaseType,
            (tthis: DeploymentStatusPopup, id: number) => {
                if (id) {
                    const spinnerSubscription = this.spinnerOverlayService.spinner$().subscribe();

                    Utils.waitForDeploymentToStart(this.http, `${this.baseUrl}${Utils.getDeploymentAPI()}/${id}`, (status) => {
                        if (status === 'SUCCESS') {
                            tthis.customDialog.openDisplayInfoDialog({ title: 'Deplyment started', message: 'Please wait until build finishes for releasing it into desired environment. Use refresh button to check whether build is generated or not.' });
                            tthis.refreshInformation();
                            spinnerSubscription.unsubscribe();
                        } else if (status === 'ERROR') {
                            tthis.customDialog.openDisplayInfoDialog({ title: 'Error', message: 'Error executing deployment. Please, contact DevOps team.' });
                            spinnerSubscription.unsubscribe();
                        }
                    });
                }
                else {
                    tthis.customDialog.openDisplayInfoDialog({ title: 'Error', message: 'Error executing deployment. Please wait a few minutes and try again. If the error persists, contact DevOps team.' });
                }
            }
        );
    }

    refreshInformation() {
        Utils.httpGetAllDeploymentStatusByControllerType(
            this.http,
            this.baseUrl,
            this,
            (tthis: DeploymentStatusPopup, values: EventArchiveStatus[]) => {
                tthis.deploymentStatusInfo = values
                Utils.httpGetLastBuildIdByInformationType(
                    tthis.http,
                    tthis.baseUrl,
                    tthis,
                    tthis.InfoTypeConf.buildReleaseType,
                    (tthis: DeploymentStatusPopup, buildRelease: BuildRelease) => {
                        tthis.buildRelease = buildRelease
                        if (tthis.buildRelease && tthis.buildRelease.BuildId !== -1)
                            Utils.httpGetReleaseByControllerTypeAndInformationType(
                                tthis.http,
                                tthis.baseUrl,
                                tthis,
                                tthis.InfoTypeConf.buildReleaseType,
                                (tthis: DeploymentStatusPopup, data: ReleaseInformation) => {
                                    tthis.environments = data.Environments
                                    if (tthis.buildRelease) tthis.buildRelease.ReleaseId = data.ReleaseId
                                    tthis.columnsToDisplay = ['environment', 'status', 'infoupdateddate', 'environmentdeploymentStatus'];
                                    tthis.deploymentStatusInfo?.forEach(x => {
                                        tthis.environments?.forEach(y => {
                                            if (y.Name.toUpperCase() === x.Environment.toUpperCase()) {
                                                x.EnvironmentDeploymentStatus = y.Status
                                                x.ReleaseEnvironmentId = y.Id
                                                if (y.Name.toUpperCase() === 'STABLE' && y.Status.toUpperCase() === 'NOTSTARTED')
                                                    x.EnvironmentDeploymentStatus = 'inProgress'
                                            }
                                        })
                                    })
                                    tthis.prodEnvironment = tthis.deploymentStatusInfo.filter(x => x.Environment.toUpperCase() == 'EA')[0]
                                    tthis.dataSource.data = tthis.deploymentStatusInfo
                                }
                            );
                        else {
                            tthis.columnsToDisplay = ['environment', 'status', 'infoupdateddate'];
                            tthis.dataSource.data = tthis.deploymentStatusInfo
                        }
                    }
                );
            }
        );
    }

    releaseEnvironment(envId: number) {
        Utils.httpReleaseEnvironmentByControllerTypeAndInformationType(
            this.http,
            this.baseUrl,
            this,
            this.InfoTypeConf.buildReleaseType,
            envId,
            (tthis: DeploymentStatusPopup, data: boolean) => {
                if (data === true) {
                    tthis.customDialog.openDisplayInfoDialog({ title: 'Release started', message: 'Please wait until deployment finishes. Use refresh button to update the information.' });
                    tthis.refreshInformation();
                }
                else
                    tthis.customDialog.openDisplayInfoDialog({ title: 'Error', message: 'Error executing deployment. Please, contact DevOps team.' });
            }
        );
    }

    // Generic helpers for template
    get InfoTypeLabel(): string {
        return this.InfoTypeConf.label;
    }

    getStatusIcon(element: any): string {
        // If statusFieldsCheck is defined, all must be truthy for success
        if (this.InfoTypeConf.statusFieldsCheck) {
            const allTrue = this.InfoTypeConf.statusFieldsCheck.every(f => !!element[f]);
            return allTrue ? 'check_circle' : 'error';
        }
        // Otherwise, just check the main statusField
        return element[this.InfoTypeConf.statusField] ? 'check_circle' : 'error';
    }

    getStatusIconTooltip(element: any): string {
        if (this.getStatusIcon(element) === 'check_circle') return 'Deployed';
        return 'Not Deployed';
    }

    getDateField(element: any): any {
        return element[this.InfoTypeConf.dateField];
    }
}
